module.exports = __webpack_public_path__ + "img/forabank.efd7ac78.png";